/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All values shown are fantasy points, not raw positions.`)
};

const es_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los valores mostrados son puntos de fantasía, no posiciones reales.`)
};

const de_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle angezeigten Werte sind Fantasy-Punkte, keine realen Positionen.`)
};

const nl_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle getoonde waarden zijn fantasy-punten, geen echte posities.`)
};

const fr_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les valeurs affichées sont des points fantasy, pas des positions réelles.`)
};

const it_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i valori mostrati sono punti fantasy, non posizioni reali.`)
};

const pt_br2_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os valores mostrados são pontos fantasy, não posições reais.`)
};

const pt_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os valores mostrados são pontos fantasy, não posições reais.`)
};

const ja_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表示されている値はすべてファンタジーポイントで、実際のポジションではありません。`)
};

const zh_f1_table_legend_intro_driver = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有显示值均为梦幻积分，而非实际名次。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_table_legend_intro_driver = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_table_legend_intro_driver(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_table_legend_intro_driver", locale)
	if (locale === "en") return en_f1_table_legend_intro_driver(inputs)
	if (locale === "es") return es_f1_table_legend_intro_driver(inputs)
	if (locale === "de") return de_f1_table_legend_intro_driver(inputs)
	if (locale === "nl") return nl_f1_table_legend_intro_driver(inputs)
	if (locale === "fr") return fr_f1_table_legend_intro_driver(inputs)
	if (locale === "it") return it_f1_table_legend_intro_driver(inputs)
	if (locale === "pt-BR") return pt_br2_f1_table_legend_intro_driver(inputs)
	if (locale === "pt") return pt_f1_table_legend_intro_driver(inputs)
	if (locale === "ja") return ja_f1_table_legend_intro_driver(inputs)
	return zh_f1_table_legend_intro_driver(inputs)
};